var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogle24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.782 12.253c0-.748-.06-1.5-.19-2.235H12.217v4.236h5.942a5.091 5.091 0 0 1-2.2 3.342v2.748h3.546c2.081-1.915 3.277-4.745 3.277-8.091Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.217 23c2.967 0 5.469-.974 7.292-2.655l-3.545-2.749c-.986.671-2.26 1.051-3.743 1.051-2.87 0-5.303-1.936-6.176-4.539H2.388v2.833A11.001 11.001 0 0 0 12.218 23Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.041 14.108a6.589 6.589 0 0 1 0-4.211V7.063H2.388a11.01 11.01 0 0 0 0 9.879l3.653-2.834Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.217 5.354a5.977 5.977 0 0 1 4.22 1.649l3.14-3.14A10.572 10.572 0 0 0 12.217 1a10.997 10.997 0 0 0-9.83 6.062l3.654 2.834c.87-2.607 3.307-4.543 6.176-4.543Z",
    fill: "#EA4335"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle24);
export default __webpack_public_path__ + "static/media/google_24.5f265853.svg";
export { ForwardRef as ReactComponent };